import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["subtotal"];

  async handleSubtotal(cartData) {
    this.subtotalTarget.innerText = `${document.body.dataset.currency}${(
      cartData.items_subtotal_price / 100
    ).toFixed(2)}`;
  }
}
